import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getStocktake = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Stocktake/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createStocktake = (payload) => {
  return axios.post(`${URL_ORI}/api/Stocktake`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdStocktake = (id) => {
  return axios
    .get(`${URL_ORI}/api/Stocktake/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateStocktake = (payload) => {
  return axios.put(`${URL_ORI}/api/Stocktake`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateStocktakeStartWorkFlow = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Stocktake/StartWorkFlow`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateStocktakeSetStatus = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Stocktake/setstatus`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateStocktakeCancel = (payload) => {
  return axios.put(`${URL_ORI}/api/Stocktake/Cancel`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const updateStocktakeConfirm = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Stocktake/Confirm`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateStocktakeAmmend = (payload) => {
  return axios.put(`${URL_ORI}/api/Stocktake/ammend`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateStocktakeComplete = (payload) => {
  return axios.put(`${URL_ORI}/api/Stocktake/Completed`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};


export const deleteStocktake = (payload) => {
  return axios.delete(`${URL_ORI}/api/Stocktake`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createStocktakeVehicles = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Stocktake/addVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};


export const createStocktakeVehiclesUnplanned = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Stocktake/AddVehiclesUnplanned`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteStocktakeVehicles = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Stocktake/deleteVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createStocktakeParties = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Stocktake/addParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadStocktake = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Stocktake/UploadStocktakeVehicle?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadPicking = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Stocktake/UploadPickingStocktake?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const uploadBTS = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios
    .post(
      `${URL_ORI}/api/Stocktake/UploadBackToStorageStocktake?object_id=${id}`,
      formData
    )
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

// Vehicle

export const getVehicle = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Stocktake/SearchVehiclesinStocktake`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createVehicle = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Stocktake/AddVehicles`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateVehicle = (payload) => {
  return axios.put(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};
export const deleteVehicle = (payload) => {
  return axios.delete(`${URL_ORI}/api/Vehicle`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// party
export const getparty = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Stocktake/searchpartyInStocktake`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const createParty = (payload) => {
  return axios
    .post(`${URL_ORI}/api/Stocktake/AddParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const updateParty = (payload) => {
  return axios
    .put(`${URL_ORI}/api/Stocktake/UpdateParty`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
export const deleteParty = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/Stocktake/deleteParties`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};